import "../assets/styles/RefundPolicy.css";

export default function RefundPolicy() {
  return (
    <div className="RefundPolicy">
      <div class="compalinace-page">
        <div class="header-conatiner">
          <div class="merchant-logo">
            <div class="logo-container">
              <div class="logo-text">Z</div>
            </div>
          </div>
          <p class="header-text">Zensark Technologies Pvt Ltd</p>
        </div>
        <div class="compalinace-content">
          <div class="content-container">
            <p class="content-head">Refund Policy</p>
            <p class="content-sub-head">Returns</p>
            <div class="content-seprater"></div>
            <p class="content-text">
              Our policy lasts 30 days. If 30 days have gone by since your
              purchase, unfortunately we can't offer you a refund or exchange.
            </p>
            <p class="content-text">
              To be eligible for a return, your item must be unused and in the
              same condition that you received it. It must also be in the
              original packaging.
            </p>
            <p class="content-text">
              Several types of goods are exempt from being returned. Perishable
              goods such as food, flowers, newspapers, Software license fees,
              Monthly subscription fee, prepaid usage fee or magazines cannot be
              returned. We also do not accept products that are intimate or
              sanitary goods, hazardous materials, or flammable liquids or
              gases.
            </p>
            <p class="content-text">
              <strong>Additional non-returnable items:</strong>
            </p>
            <ul class="unorder-list">
              <li class="list-item">
                <p class="content-text list-text">Gift cards</p>
              </li>
              <li class="list-item">
                <p class="content-text list-text">
                  Downloadable software products
                </p>
              </li>
              <li class="list-item">
                <p class="content-text list-text">
                  Some health and personal care items
                </p>
              </li>
            </ul>
            <p class="content-text">
              To complete your return, we require a receipt or proof of
              purchase.
            </p>
            <p class="content-text">
              Please do not send your purchase back to the manufacturer.
            </p>
            <p class="content-text">
              There are certain situations where only partial refunds are
              granted: (if applicable) Book with obvious signs of use CD, DVD,
              VHS tape, software, video game, cassette tape, or vinyl record
              that has been opened. Any item not in its original condition, is
              damaged or missing parts for reasons not due to our error. Any
              item that is returned more than 30 days after delivery
            </p>
            <p class="content-sub-head">Refunds (if applicable)</p>
            <p class="content-text">
              Once your return is received and inspected, we will send you an
              email to notify you that we have received your returned item. We
              will also notify you of the approval or rejection of your refund.
            </p>
            <p class="content-text">
              If you are approved, then your refund will be processed, and a
              credit will automatically be applied to your credit card or
              original method of payment, within a certain amount of days.
            </p>
            <p class="content-sub-head">Sale items (if applicable)</p>
            <p class="content-text">
              Only regular priced items may be refunded, unfortunately sale
              items cannot be refunded.
            </p>
            <p class="content-sub-head">Gifts</p>
            <p class="content-text">
              If the item was marked as a gift when purchased and shipped
              directly to you, you'll receive a gift credit for the value of
              your return. Once the returned item is received, a gift
              certificate will be mailed to you.
            </p>
            <p class="content-text">
              If the item wasn't marked as a gift when purchased, or the gift
              giver had the order shipped to themselves to give to you later, we
              will send a refund to the gift giver and he will find out about
              your return.
            </p>
            <p class="content-sub-head">Shipping</p>
            <p class="content-text">
              To return your product, you should mail your product to: 622
              Manglam Electronic Market Jaipur Rajasthan India 302001.
            </p>
            <p class="content-text">
              You will be responsible for paying for your own shipping costs for
              returning your item. Shipping costs are non-refundable. If you
              receive a refund, the cost of return shipping will be deducted
              from your refund.
            </p>
            <p class="content-text">
              Depending on where you live, the time it may take for your
              exchanged product to reach you, may vary.
            </p>
            <p class="content-text">
              If you are shipping an item over $75, you should consider using a
              trackable shipping service or purchasing shipping insurance. We
              don't guarantee that we will receive your returned item.
            </p>
            <br></br>
          </div>
        </div>
      </div>
    </div>
  );
}
